<div class="p-3 pt-2 rounded-4">

  <!-- Header -->
  <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between align-items-center">
    <div class="p-3 d-flex align-items-center gap-2">
      <button class="btn btn-sm btn-primary rounded-pill" (click)="goBack()">
        <i class="bi bi-arrow-left"></i> Back
      </button>
      <span>Customer Details</span>
    </div>
  </div>

  <!-- Loading -->
  @if (isLoading) {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Loading customer details...</p>
    </div>
  }

  <!-- Content -->
  @if (!isLoading && selectedCustomer) {
    <div class="container-fluid">
      <div class="row bg-white p-3 rounded-4 mt-2">
        <!-- Basic Info -->
        <div class="col-md-12 mb-3">
          <h5 class="btn btn-primary mt-2 text-start bg-primary-subtle text-primary border-0 w-100">
            Basic Information
          </h5>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Customer Name</div>
            <div class="col-7 text-break">: {{ getCustomer().name }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Email Id</div>
            <div class="col-7 text-break">: {{ getCustomer().emailId }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Date of Birth</div>
            <div class="col-7">: {{ formatDob(getCustomer().dob, getCustomer().citizenshipCountry?.dobFormat || getCustomer().country?.dobFormat) }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Mobile</div>
            <div class="col-7">: {{ formatMobile(getCustomer().mobile) }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Country</div>
            <div class="col-7">: {{ getCustomer().country?.displayName }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Citizenship</div>
            <div class="col-7">: {{ getCustomer().citizenshipCountry?.displayName }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Created At</div>
            <div class="col-7">: {{ dateFormat(selectedCustomer.createdAt) }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Account Status</div>
            <div class="col-7 d-flex align-items-center gap-2">
              :
              <span class="badge"
                [ngClass]="getCustomer().deletedByCustomer ? 'bg-warning' : (getCustomer().isFrozen ? 'bg-danger' : 'bg-success')">
                <i class="bi"
                [ngClass]="getCustomer().deletedByCustomer ? 'bi-trash' : (getCustomer().isFrozen ? 'bi-lock' : 'bi-check-circle')"></i>
                {{ getCustomer().deletedByCustomer ? 'DELETED' : (getCustomer().isFrozen ? 'FROZEN' : 'ACTIVE') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Customer Profile Status</div>
            <div class="col-7 d-flex align-items-center gap-2">:
              <span class="badge"
              [ngClass]="{
                'bg-secondary': customerData?.customer?.customerStatus === 'Pending' || !customerData?.customer?.customerStatus,
                'bg-warning text-dark': customerData?.customer?.customerStatus === 'In-Progress',
                'bg-success': customerData?.customer?.customerStatus === 'Approved',
                'bg-danger': customerData?.customer?.customerStatus === 'Rejected'
              }">
              {{ customerData?.customer?.customerStatus ? customerData.customer.customerStatus : '-' }}
            </span>
          </div>
        </div>
      </div>

      <!-- KYC Details -->
      <div class="col-md-12 mt-3 mb-3">
        <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
          KYC Details
        </h5>
      </div>
      <div class="col-md-6 mb-2">
        <div class="row">
          <div class="col-5 text-muted fw-semibold">Driving Licence No.</div>
          <div class="col-7">: {{ customerData?.kyc?.drivingLicenceNumber || '—' }}</div>
        </div>
      </div>
      <div class="col-md-6 mb-2">
        <div class="row">
          <div class="col-5 text-muted fw-semibold">Passport Number</div>
          <div class="col-7">: {{ customerData?.kyc?.passportNumber || '—' }}</div>
        </div>
      </div>
        <!-- Documents -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Documents
          </h5>
        </div>
        <div class="col-md-4 mb-3">
          <p class="text-muted fw-semibold mb-1">Driving Licence</p>
          @if (customerData?.kyc?.drivingLicenceImage) {
            <button type="button" class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.drivingLicenceImage)">
              <i class="bi bi-eye me-1"></i> View
            </button>
          }
          @if (!customerData?.kyc?.drivingLicenceImage) {
            <span class="text-muted">Not available</span>
          }
        </div>
        <div class="col-md-4 mb-3">
          <p class="text-muted fw-semibold mb-1">Passport</p>
          @if (customerData?.kyc?.passportImage) {
            <button type="button" class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.passportImage)">
              <i class="bi bi-eye me-1"></i> View
            </button>
          }
          @if (!customerData?.kyc?.passportImage) {
            <span class="text-muted">Not available</span>
          }
        </div>
        <div class="col-md-4 mb-3">
          <p class="text-muted fw-semibold mb-1">Selfie</p>
          @if (customerData?.kyc?.selfieImage) {
            <button type="button" class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.selfieImage)">
              <i class="bi bi-eye me-1"></i> View
            </button>
          }
          @if (!customerData?.kyc?.selfieImage) {
            <span class="text-muted">Not available</span>
          }
        </div>
        <!-- Intelliwings -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Intelliwings Reponse
          </h5>
        </div>
        @if (!intelliWingsResponse) {
          <div class="col-md-2">
            <button class="btn btn-info" (click)="verifyWithIntelliWings()">Verify</button>
          </div>
        }
        @if (intelliWingsResponse) {
          <div class="col-md-4">
            <div class="row">
              <div class="col-5 text-muted fw-semibold">Status</div>
              <div class="col-7">: {{ intelliWingsResponse?.status }}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-3 text-muted fw-semibold">Request Id</div>
              <div class="col-9">: {{ intelliWingsResponse?.requestId }}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-5 text-muted fw-semibold">UCIC</div>
              <div class="col-7">: {{ intelliWingsResponse?.ucic }}</div>
            </div>
          </div>
          <div class="col-md-12">
            <div>
              <span class="text-muted fw-semibold">Message : </span> <span class="message-text">{{intelliWingsResponse?.message}}</span>
            </div>
          </div>
          @if (intelliWingsResponse?.matches?.sanction.length > 0) {
            <div class="col-md-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>SANCTION</th>
                  </tr>
                  <tr>
                    <th>SNO</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Source Link</th>
                    <th>Summary</th>
                    <th>Identifier</th>
                  </tr>
                </thead>
                <tbody>
                  @for (k of intelliWingsResponse?.matches?.sanction; track k; let index = $index) {
                    <tr>
                      <td>{{index + 1}}</td>
                      <td>{{k.type}}</td>
                      <td>{{k.name}}</td>
                      <td>
                        <a [href]="k.sourcelink" target="_blank" rel="noopener noreferrer">View</a>
                      </td>
                      <td>{{k.summary}}</td>
                      <td>{{k.identifier?.[0]?.identifiernumber}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (intelliWingsResponse?.matches?.pep.length > 0) {
            <div class="col-md-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>PEP</th>
                  </tr>
                  <tr>
                    <th>SNO</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Nationality</th>
                    <th>Source Link</th>
                    <th>Match Id</th>
                  </tr>
                </thead>
                <tbody>
                  @for (k of intelliWingsResponse?.matches?.pep; track k; let index = $index) {
                    <tr>
                      <td>{{index + 1}}</td>
                      <td>{{k.type}}</td>
                      <td>{{k.fullName}}</td>
                      <td>{{k.nationality }}</td>
                      <td>
                        <a [href]="k.sourceurl" target="_blank" rel="noopener noreferrer">View</a>
                      </td>
                      <td>{{k.matchid}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (intelliWingsResponse?.matches?.adversemedia.length > 0) {
            <div class="col-md-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Adverse Media</th>
                  </tr>
                  <tr>
                    <th>SNO</th>
                    <th>Match Score</th>
                    <th>Person</th>
                    <th>Article Date</th>
                    <th>Source Link</th>
                    <th>Article Keywords</th>
                  </tr>
                </thead>
                <tbody>
                  @for (k of intelliWingsResponse?.matches?.adversemedia; track k; let index = $index) {
                    <tr>
                      <td>{{index + 1}}</td>
                      <td>{{k.matchScore}}</td>
                      <td>{{k.personMatched}}</td>
                      <td>{{k.articleDate }}</td>
                      <td>
                        <a [href]="k.articleURL" target="_blank" rel="noopener noreferrer">View</a>
                      </td>
                      <td>{{k.keywordUsedForIdentifingTheArticle}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        }
        <!-- Account Details -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Account Details
          </h5>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Account Name</div>
            @if (customerData?.customer?.customerStatus === 'Approved') {
              <div class="col-7">: {{ customerData?.partner?.name || '—' }}</div>
            }
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Account Number</div>
            @if (customerData?.customer?.customerStatus === 'Approved') {
              <div class="col-7">: {{ customerData?.partner?.accountNumber || '—' }}</div>
            }
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Routing Number</div>
            @if (customerData?.customer?.customerStatus === 'Approved') {
              <div class="col-7">: {{ customerData?.partner?.routingNumber || '—' }}</div>
            }
          </div>
        </div>
        <!-- Beneficiaries -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Beneficiaries
          </h5>
        </div>
        @if (beneficiaries.length === 0) {
          <div class="col-md-12">
            <p class="text-muted">No beneficiaries found for this customer.</p>
          </div>
        }
        @if (beneficiaries.length > 0) {
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered table-hover align-middle">
                <thead class="table-light">
                  <tr>
                    <th>Action</th>
                    <th>#</th>
                    <th>Beneficiary Name</th>
                    <th>Account Number</th>
                    <th>Mobile Number</th>
                    <th>Bank Details</th>
                    <th>Status</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  @for (b of beneficiaries; track b; let i = $index) {
                    <tr>
                      <td>
                        <button class="btn btn-sm btn-primary active rounded-pill" (click)="viewBeneficiaryTransactions(b)">
                          <i class="bi bi-eye-fill"></i>
                        </button>
                      </td>
                      <td>{{ i + 1 }}</td>
                      <td>{{ b.beneficiaryName }}</td>
                      <td>{{ b.accountNumber || b.billerId?.bankAccount?.accountNumber || getFirstFieldValue(b.customerFields) || '—' }}</td>
                      <td>{{ formatBeneficiaryMobile(b.mobileNumber, b) }}</td>
                      <td>
                        @if (!b.isBill && b.dynamicFields) {
                          <div>
                            @for (key of getDynamicFieldKeys(b.dynamicFields); track key) {
                              <div class="small">
                                <span class="text-muted">{{ key }}:</span> {{ b.dynamicFields[key] }}
                              </div>
                            }
                          </div>
                        }
                        @if (b.isBill && b.billerId?.bankAccount) {
                          <div>
                            <div class="small">
                              <span class="text-muted">Bank:</span> {{ b.billerId.bankAccount.bankName }}
                            </div>
                            <div class="small">
                              <span class="text-muted">SWIFT:</span> {{ b.billerId.bankAccount.swiftCode }}
                            </div>
                          </div>
                        }
                      </td>
                      <td>
                        <span class="badge" [ngClass]="b.isActive ? 'bg-success' : 'bg-danger'">
                          {{ b.isActive ? 'Active' : 'Inactive' }}
                        </span>
                      </td>
                      <td>{{ dateFormat(b.createdAt) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        <!-- Comments -->
        <div class="col-md-12 mb-3">
          <h5 class="btn btn-primary mt-2 text-start bg-primary-subtle text-primary border-0 w-100 d-flex justify-content-between align-items-center">
            <span>Comments Details</span>
            <button class="btn btn-sm btn-outline-primary rounded-pill" (click)="refreshComments()" title="Refresh comments">
              <i class="bi bi-arrow-clockwise"></i> Refresh
            </button>
          </h5>
        </div>
        @if (customerData?.customer) {
          <div>
            @for (d of customerData?.customer?.comments; track d) {
              <div
                class="bg-light border-start border-primary border-4 rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <div>
                    <strong>{{ d.userName }}</strong>
                    <span class="text-muted">({{ d.role }})</span>
                  </div>
                  <small class="text-muted">
                    {{ d.date | date:'dd MMM yyyy, hh:mm a' }}
                  </small>
                </div>
                <div class="mb-0 mt-2 bg-transparent border-0 p-0">{{ d.comment }} </div>
              </div>
            }
            @if (customerData?.customer?.customerStatus !== 'Approved' && customerData?.customer?.customerStatus !== 'Rejected') {
              <div class="col-md-12">
                <textarea class="form-control resize-none" name="cmnt" rows="3" [(ngModel)]="comment"
                placeholder="Enter comment"></textarea>
              </div>
            }
          </div>
        }
        <!-- Status update -->
        @if (customerData?.customer?.customerStatus !== 'Approved' && customerData?.customer?.customerStatus !== 'Rejected') {
          <div class="text-end mt-3">
            <div class="btn btn-sm btn-warning" (click)="onCustomerUpdateStatus('In-Progress')">In-Progress</div>
            <div class="btn btn-sm btn-success ms-3" (click)="onCustomerUpdateStatus('Approved')">Approve</div>
            <div class="btn btn-sm btn-danger ms-3" (click)="onCustomerUpdateStatus('Rejected')">Reject</div>
          </div>
        }
      </div>
    </div>
  }

  <!-- No data -->
  @if (!isLoading && !selectedCustomer) {
    <div class="text-center py-5 text-muted">
      <i class="bi bi-person-x fs-1"></i>
      <p class="mt-2">Customer not found.</p>
      <button class="btn btn-primary rounded-pill" (click)="goBack()">Go Back</button>
    </div>
  }
</div>
